import { useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import PropTypes from "prop-types";

export const LazyImage = ({
  src = "",
  alt = "emlakjet-image-not-found",
  className,
  width = "auto",
  height = "auto",
  wrapperClassName,
  style,
  visibleByDefault,
  ...props
}) => {
  const [imageSrc, setImageSrc] = useState(src);

  const handleErrorImage = () => {
    setImageSrc("/assets/images/no_photo_big.jpg");
  };

  return (
    <LazyLoadImage
      src={imageSrc}
      alt={alt}
      className={className}
      width={width}
      height={height}
      wrapperClassName={wrapperClassName}
      style={style}
      threshold={400}
      visibleByDefault={visibleByDefault}
      onError={handleErrorImage}
      {...props}
    />
  );
};

LazyImage.propTypes = {
  src: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  alt: PropTypes.string,
  className: PropTypes.string,
  wrapperClassName: PropTypes.string,
  style: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  visibleByDefault: PropTypes.bool,
};
